define([
  "jquery",
  "underscore",
  "marionette",
  "forms/demo_account/additional_account_form",
  "behaviors/form_errors_behavior",
  "behaviors/signature_behavior",
  "backbone.syphon",
], function (
  $,
  _,
  Marionette,
  AdditionalAccountForm,
  FormErrorsBehavior,
  SignatureBehavior
) {
  return Marionette.View.extend({
    el: "#content_layout",

    behaviors: {
      formErrors: {
        behaviorClass: FormErrorsBehavior,
      },
      signature: {
        behaviorClass: SignatureBehavior,
      },
    },

    ui: {
      submitBtn: "#submit_btn",

      currencyCd: "#currency_cd",
      currencyAbbr: "#currency_abbr",
      currencies: "#currencies",
      leverage: "#leverage",
      leverages: "#leverages",
      memberTypes: "#member_types",
      demoMemberTypeName: "#demo_member_type_name",

      hold_on_overlay: "#holdon-overlay",

      newSelectBox: ".new-select-box",
      newSelectBoxLabel: ".new-select-box > div",
      newSelectBoxImage: ".new-select-box > img",

      newSelectBoxClick: ".dropdown-wrapper li",

      eyeBtn: ".show_password_btn_img",

      passwordInput: "#password",
      confirmPasswordInput: "#confirm_password",
    },

    events: {
      "click @ui.submitBtn": "submit",
      "click @ui.eyeBtn": "triggerEyeBtn",
      "change @ui.demoMemberTypeName": function (e) {
        this.requestReadyInfoAndUpdateCurrencyAndLeverage();
      },
      "change @ui.currencyAbbr": function (e) {
        this.requestReadyInfoAndUpdateLeverage();
      },
      "click @ui.newSelectBox": function (e) {
        this.displaySorterSelectBox(e);
      },
      "click @ui.newSelectBoxLabel": function (e) {
        this.unDisplaySelectBox(e);
        this.displaySorterSelectBoxByLabel(e);
      },
      "click @ui.newSelectBoxImage": function (e) {
        this.displaySorterSelectBoxByImage(e);
      },
      "click @ui.newSelectBoxClick": function (e) {
        this.changeLabel(e);
        this.changeInputVal(e);
      },
      click: function (e) {
        if (e.target.id === "content_layout") {
          this.unDisplaySelectBox(e);
        }
      },
      "keyup @ui.passwordInput": "passwordValidation",
      "keyup @ui.confirmPasswordInput": "isSamePasswordValidation",
    },

    initialize: function () {
      this.bindUIElements();
      this.leverage_list = [];
      this.currency_list = [];
      this.requestReadyInfoAndUpdateCurrencyAndLeverage(true);
    },

    passwordValidation: function (e) {
      let password = e.target.value;
      let errorFound = false;

      // 글자수 8자 이상, 15자 이하
      let lengthRule = /^.{8,15}$/;
      if (lengthRule.test(password)) {
        document.getElementsByClassName("length")[0].style.display = "none";
      } else {
        errorFound = true;
        document.getElementsByClassName("length")[0].style.display = "flex";
      }

      // 숫자 하나 이상 포함
      let digitRule = /\d/;
      if (digitRule.test(password)) {
        document.getElementsByClassName("number")[0].style.display = "none";
      } else {
        errorFound = true;
        document.getElementsByClassName("number")[0].style.display = "flex";
      }

      // 특수문자 하나 이상 포함
      let specialCharRule = /[!@#$%^*+=-]+/;
      if (specialCharRule.test(password)) {
        document.getElementsByClassName("special-character")[0].style.display =
          "none";
      } else {
        errorFound = true;
        document.getElementsByClassName("special-character")[0].style.display =
          "flex";
      }

      // 염문 대문자/소문자 포함
      let uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
      if (uppercaseRule.test(password)) {
        document.getElementsByClassName("uppercase")[0].style.display = "none";
      } else {
        errorFound = true;
        document.getElementsByClassName("uppercase")[0].style.display = "flex";
      }

      if (errorFound) {
        document.getElementsByClassName(
          "first-validation-box"
        )[0].style.display = "flex";
      } else {
        document.getElementsByClassName(
          "first-validation-box"
        )[0].style.display = "none";
      }
    },

    isSamePasswordValidation: function (e) {
      let passwordForConfirm = e.target.value;
      if (document.getElementById("password").value === passwordForConfirm) {
        document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
          "none";
      } else {
        document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
          "flex";
      }
    },

    updateLeverageList: function (isInit = false) {
      let optionsString = "";

      if (isInit) {
        updatedLeverages = window.init_leverage;
      } else {
        updatedLeverages = this.leverage_list;
      }

      this.ui.leverages.html("");
      _.each(updatedLeverages, function (item, index) {
        optionsString +=
          "<li data-value='" +
          item.leverage +
          "'>" +
          item.leverageName +
          "</li>";
      });
      this.ui.leverages.append(optionsString);

      this.ui.leverage.val(this.ui.leverages.find("li").last().data("value"));
      const divLabel = this.ui.leverages.parent().find("div").first();
      divLabel.html(this.ui.leverages.find("li").last().html());
    },

    updateCurrencyList: function (isInit = false) {
      let optionsString = "";

      if (isInit) {
        updatedCurrencies = window.init_currency;
      } else {
        updatedCurrencies = this.currency_list;
      }

      this.ui.currencies.html("");
      _.each(updatedCurrencies, function (item, index) {
        optionsString +=
          "<li data-value='" +
          item.currencyAbbr +
          "'>" +
          item.currencyAbbr +
          "</li>";
      });
      this.ui.currencies.append(optionsString);

      this.ui.currencyCd.val(
        this.ui.currencies.find("li").first().data("value")
      );
      const divLabel = this.ui.currencies.parent().find("div").first();
      divLabel.html(this.ui.currencies.find("li").first().html());
    },

    requestReadyInfoAndUpdateCurrencyAndLeverage: function (isInit = false) {
      let that = this;

      HoldOn.open({
        theme: "sk-fading-circle",
      });

      const lang = window.lang;
      const currency_abbr = this.ui.currencyAbbr.val();
      const demo_member_type_name = this.ui.demoMemberTypeName.val();

      requestBody = {
        lang,
        demo_member_type_name,
        currency_abbr,
      };

      $.ajax("/rest_demo_account/ready_list", {
        method: "GET",
        data: requestBody,
        success: function (data) {
          that.leverage_list = data["leverages"];
          that.currency_list = data["currencies"];
          that.updateCurrencyList(isInit);
          that.updateLeverageList(isInit);

          HoldOn.close();
        },
      });
    },

    requestReadyInfoAndUpdateLeverage: function (isInit = false) {
      let that = this;

      HoldOn.open({
        theme: "sk-fading-circle",
      });

      const lang = window.lang;
      const currency_abbr = this.ui.currencyAbbr.val();
      const demo_member_type_name = this.ui.demoMemberTypeName.val();

      requestBody = {
        lang,
        demo_member_type_name,
        currency_abbr,
      };

      $.ajax("/rest_demo_account/ready_list", {
        method: "GET",
        data: requestBody,
        success: function (data) {
          that.leverage_list = data["leverages"];
          that.updateLeverageList(isInit);

          HoldOn.close();
        },
      });
    },

    submit: function (e) {
      e.preventDefault();
      this.ui.submitBtn.attr("disabled", true);

      this.triggerMethod("hide:errors");

      const formData = Backbone.Syphon.serialize(this.$("#form_submit")[0]);
      const form = new AdditionalAccountForm();
      form.set(formData);

      const errors = form.validate();

      const that = this;
      if (_.size(errors) < 1) {
        HoldOn.open({
          theme: "sk-fading-circle",
        });
        $("#holdon-overlay").show();
        form.validateWithServer({
          type: "POST",
          success: function (model, res) {
            that.ui.submitBtn.attr("disabled", false);
            that.$("#form_submit").submit();
            that.ui.submitBtn.attr("disabled", true);
          },
          error: function (model, error) {
            that.ui.submitBtn.attr("disabled", false);
            $("#holdon-overlay").hide();
            that.triggerMethod("show:errors", error.responseJSON);
            HoldOn.close();
          },
        });
      } else {
        that.ui.submitBtn.attr("disabled", false);
        this.triggerMethod("show:errors", errors);
      }
    },

    displaySorterSelectBox: function (e) {
      const selectBox = $(event.target).children("ul");

      if (selectBox.css("display") === "none") {
        $(".dropdown-wrapper").hide();
      }

      selectBox.toggle();
    },

    displaySorterSelectBoxByLabel: function (e) {
      const selectBox = $(event.target).parent().children("ul");
      selectBox.toggle();
    },

    displaySorterSelectBoxByImage: function (e) {
      const selectBox = $(event.target).parent().children("ul");

      if (selectBox.css("display") === "none") {
        $(".dropdown-wrapper").hide();
      }

      selectBox.toggle();
    },

    changeLabel: function (e) {
      const liValue = $(event.target).html();
      const ul = $(event.target).parent();
      const selectBox = ul.parent();
      const divLabel = selectBox.children("div");
      ul.toggle();
      divLabel.html(liValue);
    },

    changeInputVal: function (e) {
      const liValue = $(event.target).data("value");
      const ul = $(event.target).parent();
      const selectBox = ul.parent();
      const input = selectBox.next("input");
      input.val(liValue).change();
    },

    unDisplaySelectBox: function (e) {
      $(".dropdown-wrapper").hide();
    },

    triggerEyeBtn: function (e) {
      const eyeBtn = $(e.currentTarget);
      const password = $(e.currentTarget).parent().parent().find(".password");
      const type = password.attr("type");
      if (type === "text") {
        password.attr("type", "password");
        eyeBtn.attr("src", "/assets/common/common/img/eye_icon_gray.svg");
      } else {
        password.attr("type", "text");
        eyeBtn.attr("src", "/assets/common/common/img/hide_eye_gray.svg");
      }
    },
  });
});
